import * as React from 'react'

function SvgIconBlacksmithing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="blacksmithing" aria-labelledby="t-blacksmithing d-blacksmithing">
        <title id="t-blacksmithing">{'Blacksmithing'}</title>
        <desc id="d-blacksmithing">{'An anvil'}</desc>
        <path d="M31 5H10c-.6 0-1 .4-1 1H1c-.6 0-1 .4-1 1 0 2.9 3.9 5 9 5v2c0 .6.4 1 1 1 1.1 0 2 1.3 2 3s-.9 3-2 3H5c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h22c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-5c-1.1 0-2-1.3-2-3s.9-3 2-3c.6 0 1-.4 1-1 0-1.9 3.3-4 8-4 .6 0 1-.4 1-1V6c0-.6-.4-1-1-1zM1 7h8v4c-4.5 0-8-1.8-8-4zm26 15v4H5v-4h22zm-8-4c0 1.2.4 2.3 1 3h-8c.6-.7 1-1.8 1-3s-.4-2.3-1-3h8c-.6.7-1 1.8-1 3zm12-9c-5 0-9 2.2-9 5H10V6h21v3z" />
      </g>
    </svg>
  )
}

export default SvgIconBlacksmithing
